@if (tokenTypes()) {
    @for (tokenType of tokenTypes(); track tokenType) {
        <div class="ap-sign-selector__token-type" [attr.data-bb]="'signOption_' + tokenType.ids.toString()">
            @if (tokenType.redirect) {
                <ap-button-link [href]="'sign.token.selector.browser.register.link' | apContent" [iconName]="tokenType.icon">
                    {{ 'sign.token.selector.' + tokenType.name | apContent }}
                </ap-button-link>
            }
            @if (!tokenType.redirect) {
                <ap-button
                    (onClick)="select(tokenType.ids)"
                    [iconName]="tokenType.icon"
                    [isDisabled]="tokenType.disabled"
                    [attr.aria-describedby]="tokenType.helpText ? 'tokenType.helpText.' + tokenType.name : null"
                >
                    {{ 'sign.token.selector.' + tokenType.name | apContent }}
                </ap-button>
            }
            @if (tokenType.helpText) {
                <p
                    class="ap-small ap-sign-selector__help-text"
                    [innerHTML]="tokenType.helpText"
                    [id]="'tokenType.helpText.' + tokenType.name"
                ></p>
            }
        </div>
    }
    <ng-content></ng-content>
    @if (!!rememberControl()) {
        <ap-checkbox [label]="'sign.token.selector.remember' | apContent" [formControl]="rememberControl()"></ap-checkbox>
    }
}
